import {
  Box,
  Button,
  ButtonGroup,
  Icon,
  ListItem,
  Typography,
  Popover,
} from "@mui/material";
import { useState } from "react";
import {
  IconCloudDownload,
  IconX,
  IconTrashX,
  IconCode,
} from "@tabler/icons-react";
import { useUsuario } from "../../../../providers/usuarioProvider";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import UploadInternacional from "../../../../models/uploadInternacional";
import { deleteDoc } from "firebase/firestore";
import UploadInternacionalDb from "../../../../db/uploadInternacionalDb";

type Props = {
  upload: UploadInternacional;
};

export default function StatementComErro({ upload }: Props) {
  const { visualizado } = useUsuario();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <ListItem disableGutters sx={{ px: 2, py: 1 }}>
      <Box display="flex" flexDirection="column" style={{ width: "100%" }}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Icon color="error" fontSize="inherit" sx={{ width: 16 }}>
            <IconX size={16} strokeWidth={3} />
          </Icon>
          <Box display="flex" flexGrow={1} px={1}>
            <Typography variant="body1" fontWeight={600} color="error.main">
              Erro ao importar statement (
              <Typography
                variant="dataMono"
                component="span"
                color="text.secondary"
              >
                {upload.nomeArquivoOriginal}
              </Typography>
              )
            </Typography>
            {upload.erro && (
              <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={0.5}
                  p={1.5}
                  sx={{ maxWidth: 420 }}
                >
                  <Typography
                    variant="labelMono"
                    color="text.secondary"
                  >{`Erro: ${upload.erro.codErro}`}</Typography>
                  {upload.erro.detalhes && (
                    <Typography
                      variant="dataMono"
                      fontSize={12}
                      color="text.primary"
                      sx={{ wordBreak: "break-word" }}
                    >{`Detalhes: ${upload.erro.detalhes}`}</Typography>
                  )}
                </Box>
              </Popover>
            )}
          </Box>
          <ButtonGroup size="small" variant="outlined">
            {upload.erro && (
              <Button
                size="small"
                color="info"
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <IconCode size={16} />
              </Button>
            )}
            <Button
              color="info"
              size="small"
              onClick={async () =>
                await getDownloadURL(
                  ref(
                    getStorage(),
                    `/usuarios/${visualizado}/uploadsInternacionais/${upload.id}`
                  )
                ).then((url) => window.open(url))
              }
            >
              <IconCloudDownload size={16} />
            </Button>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                if (!!visualizado)
                  await deleteDoc(
                    new UploadInternacionalDb().doc({
                      usuarioId: visualizado,
                      uploadId: upload.id,
                    })
                  );
              }}
            >
              <IconTrashX size={16} />
            </Button>
          </ButtonGroup>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="space-between"
          alignItems="flex-start"
          py={1}
          pl={3}
        >
          <Typography variant="body2" color="text.secondary">
            {upload.erro?.erro || "Erro desconhecido."}
          </Typography>
        </Box>
      </Box>
    </ListItem>
  );
}
